import { useState } from 'react';
import YneJoy_logo from "../../src/assets/homepage/LOGOHeader.png";
import Meteri_logo from "../../src/assets/homepage/SelezioneVini_colore2.svg"
import YneJoy_logo_footer from "../../src/assets/homepage/MainLogo.png";
import Yellowcircle from "../../src/assets/homepage/yellowcircle.png";
import Meteri_Ipad_logo from "../../src/assets/homepage/ipad.png";
import Meteri_Ipad_yellow from "../../src/assets/homepage/yellowcircle.png";
import Meteri_Ipad_gls from "../../src/assets/homepage/ipadnew-inner-.png";
import WebForm from './WebForm';

const MainPage = () => {

  const [showModalWebForm, setShowModalWebForm] = useState(false);

  return (
    <>
      <div className='main-page bg-[#fff0c8] h-auto'>
        <div className='container w-full max-w-full m-auto bg-[#fff0c8] overflow-hidden'>
          <div className='main-inner'>
            <div className='logo-top max-w-[300px] mx-auto pt-[20px]'>
              <img src={YneJoy_logo} alt="" />
            </div>
            {/* new div */}
            <div className='flex-wrap lg:flex-nowrap flex my-[40px] lg:my-[100px]'>
              <div className='relative max-w-[360px] mb-[20px] mt-[20px]'>
                <div className="max-w-[260px] min-w-[380px] relative left-[-150px] bg-no-repeat bg-contain bg-center h-[310px]"
                  style={{ backgroundImage: `url(${Yellowcircle})` }}>
                  <div className="logo-ynejoy flex items-center justify-center w-full relative left-[120px] sm:left-[135px] md:left-[160px] top-[80px] md:top-[80px]">
                    <div className="text-left text-[40px] leading-[50px] md:text-[50px] md:leading-[60px] text-[#1e72a4] font-bold whitespace-nowrap">SOMMELIER <div> VIRTUALE </div> <span className='text-sm '><p>La soluzione per il futuro della</p><p>ristorazione</p></span></div>
                  </div>
                </div>
              </div>
              <div className='w-full max-w-full lg:max-w-[calc(100%-380px)] ml-auto pr-[20px] md:pr-5'>
                <div className='relative max-w-[220px] sm:max-w-[450px] flex justify-center lg:justify-end ml-auto sm:mx-auto lg:mr-0 lg:ml-auto  pr-0 md:pr-[10px]'>
                  <img src={Meteri_Ipad_yellow} alt="" className='w-[150px] sm:w-[200px] absolute left-[-68px] sm:left-[-10px] md:left-[-50px] lg:left-[33px] z-0 top-1/2 -translate-y-1/2' />
                  <div className='relative'>
                    <img src={Meteri_Ipad_gls} alt="" className='w-[300px] absolute z-[1] w-full h-full bottom-[2px] left-[-4px]' />
                    <img src={Meteri_Ipad_logo} alt="" className='relative w-[300px]  rounded-3xl' />
                  </div>
                </div>
              </div>
            </div>
            {/* new div */}
            <div className='flex-wrap justify-end lg:flex-nowrap flex my-[40px] lg:my-[100px]'>
              <div className='w-full max-w-full order-1 lg:order-none lg:max-w-[590px] mr-auto px-[15px] lg:pl-8'>
                <div className="mt-3 w-full h-[350px] lg:h-full border border-gray-300 rounded-md flex items-center justify-center">
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/DBK46PnNl2I?si=Er5Q03Mh6SA3dYEC"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    className="rounded-md"
                  />
                  {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/5NhIaML7nTg?si=DphgogACWbHSqbLM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
                </div>
              </div>
              <div className='relative max-w-[360px] ml-auto mb-[20px] mt-[20px] right-[-100px]'>
                <div className="max-w-[260px] min-w-[380px] relative left-[0px] bg-no-repeat bg-contain bg-center h-[310px]"
                  style={{ backgroundImage: `url(${Yellowcircle})` }}
                >
                  <div className="logo-ynejoy flex items-center justify-center w-full relative left-[0px] top-[50px]">
                    <div className="text-left text-[40px] leading-[50px] md:text-[50px] md:leading-[60px] text-[#1e72a4] absolute right-[180px] top-[50px] text-right font-bold whitespace-nowrap">COME <div> FUNZIONA</div> </div>
                  </div>
                </div>
              </div>
            </div>
            {/* new div */}
            <div className='flex-wrap items-center justify-start  lg:flex-nowrap flex my-[100px] mb-[50px]'>
              <div className='relative max-w-[360px] mb-[20px]  mt-[20px]'>
                <div className="max-w-[260px] min-w-[380px] relative left-[-150px] bg-no-repeat bg-contain bg-center h-[310px]"
                  style={{ backgroundImage: `url(${Yellowcircle})` }}
                >
                  <div className="logo-ynejoy flex items-center justify-center w-full relative left-[120px] sm:left-[140px] sm:left-[135px] lg:left-[160px] top-[80px] md:top-[70px]">
                    <div className="text-left text-[40px] leading-[50px] md:text-[50px] md:leading-[60px] text-[#1e72a4] font-bold whitespace-nowrap">COSA <div> DICONO DI </div> NOI?</div>
                  </div>
                </div>
              </div>
              <div className="w-full max-w-[356px] h-[570px] mx-auto lg:mr-0 lg:ml-auto px-[15px] lg:pr-5">
                <div className="mt-3 w-full h-full lg:h-full border border-gray-300 rounded-md flex items-center justify-center">
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/bp6jcJlLkw8"
                    title="YouTube Shorts video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    className="rounded-md"
                  />
                </div>
              </div>

            </div>
            <div className=''>
              <h3 className='text-center text-[35px] sm:text-[46px] md:text-[65px] poppins-medium text-[#2274a5] mb-[30px]  mt-[100px]'>RICHIEDI UNA DEMO</h3>
              <div className='web_Form mb-10'>
                <WebForm
                  closeModal={() => { setShowModalWebForm(false) }}
                />
              </div>
            </div>
            <p className="text-center text-[30px] md:text-[46px] poppins-light text-[#2274a5]">È la soluzione di</p>
            <div className='relative max-w-[360px] mb-[20px] m-auto mt-[20px]'>
              <div className='max-w-[350px] m-auto'>
                <div className="logo-meteri flex items-center justify-center">
                  <a
                    href="https://www.meteri.it/shop/it/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={Meteri_logo} alt="Meteri Logo" />
                  </a>
                </div>
              </div>
            </div>
            <p className="text-center text-[25px] sm:text-[36px] md:text-[45px] poppins-light text-[#2274a5] mb-[20px]">per la ristorazione di domani</p>
          </div>

          <div className='footer_pdf flex items-center bg-[#1e6e9d] px-[20px] py-[40px]'>
            <div className="flex items-center flex-wrap md:flex-nowrap justify-center md:justify-between w-full text-white ">
              <div className="flex items-cfenter justify-center md:justify-start mb-[30px] md:mb-0 gap-4 w-full  ">
                <img src={YneJoy_logo_footer} alt="logo" className="w-full max-w-[300px]" />
              </div>
              <div className="text-sm text-right text-black ">
                <p className="text-black text-2xl md:text-3xl"><a href="mailto:info@yne&joy.com">info@yne&joy.com</a></p>
                <p className="text-black text-2xl md:text-3xl text-left mt-3"><a href="tel:+393457860381" className='whitespace-nowrap'>+39 345 7860381</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {showModalWebForm &&
        <WebForm
          closeModal={() => { setShowModalWebForm(false) }}
        />} */}

    </>
  )
}

export default MainPage;